import {
  CREATE_STAFF_USER_REQUEST,
  CREATE_STAFF_USER_SUCCESS,
  CREATE_STAFF_USER_FAILURE,
  GET_STAFF_USER_REQUEST,
  GET_STAFF_USER_SUCCESS,
  GET_STAFF_USER_FAILURE,
} from "../../Constants/school_user/addStaffUser";

const initialState = {
  payload: null,
  staffUser: null,
  StaffUser: null,
  loading: false,
  error: null,
};

export const getStaffUser = (state = initialState, action) => {
  switch (action.type) {
    case GET_STAFF_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_STAFF_USER_SUCCESS:
      return {
        ...state,
        StaffUser: action.payload,
        loading: false,
        error: null,
      };
    case GET_STAFF_USER_FAILURE:
      return {
        ...state,
        loading: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const addStaffUser = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_STAFF_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_STAFF_USER_SUCCESS:
      return {
        ...state,
        staffUser: action.payload,
        loading: false,
        error: null,
      };
    case CREATE_STAFF_USER_FAILURE:
      return {
        ...state,
        loading: true,
        error: action.payload,
      };
    default:
      return state;
  }
};
